module.exports = __webpack_public_path__ + "static/media/medicine@2x.76a8a149.png";